import {
  GameCategory,
  GamesCategoriesClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gamesCategoriesClient = new GamesCategoriesClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleGetGameCategories = async (
  shouldFetchAll?: boolean
): Promise<GameCategory[] | undefined> => {
  return (await gamesCategoriesClient.getGameCategories(shouldFetchAll)).data
    .records;
};

export { handleGetGameCategories };
